'use client';

import {Link, usePathname, useRouter} from '@/i18n/navigation';
import {useLocale} from 'next-intl';
import 'swiper/css';
import 'swiper/css/navigation';
import './Header.scss';

const Header = () => {
  const lngs: {[key: string]: {nativeName: string; full: string}} = {
    zh: {nativeName: '中文', full: '繁體中文'},
    en: {nativeName: 'EN', full: 'English'}
  };
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const handleLanguageChange = (lng: any) => {
    router.push(pathname, {locale: lng});
    router.refresh();
  };

  return (
    <header>
      <div className="header">
        <Link prefetch={false} href={'/smile-meter'}>
          <img
            alt="img"
            className="logo"
            src={`/img/smile/ASW 185YRS Lock-up-English-01 1.png`}
          />
        </Link>
        <div className="lang-selector-container">
          <div className="lang-selected">
            {Object.keys(lngs)
              .filter((e) => e != locale)
              .map((lng) => (
                <div
                  key={lng}
                  className={`lang ${locale === lng ? 'active' : ''}`}
                  onClick={() => handleLanguageChange(lng)}
                >
                  {lngs[lng].nativeName}
                </div>
              ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
